module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABlSURBVHgBzZDtCcAgDESTTmI3cDRH6AYdrSO0m1wTqLRQP6L4wweHQe+BhGg0ADbJ3iI4yYEXnV1N8pITf/TO56SAOiH2+SOCDLCg50KdzCOu/KBzqpBcTlxA6W3IVy9D39IpcwOuFG+oKxdjywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yi2.png
// module id = vgO0
// module chunks = 1